// extracted by mini-css-extract-plugin
module.exports = {"notificationBar":"NoticeBar_notificationBar__1NMtD","barCopy":"NoticeBar_barCopy__1A6sh","link":"NoticeBar_link__1DMwB","dismiss":"NoticeBar_dismiss__AR6yE"};